var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.11328 4.95996L7.99994 8.36662L13.8466 4.97994",
    stroke: "#004EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.4065V8.35986",
    stroke: "#004EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6204 1.6535L3.0604 3.63352C2.25374 4.08018 1.59375 5.20017 1.59375 6.12017V9.88685C1.59375 10.8069 2.25374 11.9268 3.0604 12.3735L6.6204 14.3535C7.3804 14.7735 8.62706 14.7735 9.38706 14.3535L12.9471 12.3735C13.7537 11.9268 14.4137 10.8069 14.4137 9.88685V6.12017C14.4137 5.20017 13.7537 4.08018 12.9471 3.63352L9.38706 1.6535C8.6204 1.22683 7.3804 1.22683 6.6204 1.6535Z",
    stroke: "#004EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3325 8.82674V6.38676L5.00586 2.7334",
    stroke: "#004EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBox);
export default __webpack_public_path__ + "static/media/blueBox.30c5904af020dac62ba548224cbd655d.svg";
export { ForwardRef as ReactComponent };